import styled, { css } from 'styled-components';
import { Question } from './Question';
import { AnswerCell } from './AnswerCell';
import { useGame } from '../providers/GameProvider/GameProvider';
import { useThemeMode } from '../theme';

const Container = styled.div`
  display: grid;
  width: 100%;
  max-width: 650px;
  aspect-ratio: 1/1;
  grid-template-rows: repeat(4, 1fr);
  grid-template-columns: repeat(4, 1fr);
  color: ${({ theme }) => theme.text.default};

  font-family: Jost;
  font-weight: 400;

  @media (max-width: 630px) {
    font-size: 0.7rem;
  }
`;

const YAxisQuestionsList = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;

  grid-area: 1 / 1 / 4 / 2;
`;

const XAxisQuestionsList = styled.div`
  display: flex;
  height: 100%;
  flex-direction: row;

  grid-area: 4 / 2 / 5 / 5;
`;

const MainGrid = styled.div(
  ({ theme }) => css`
    display: grid;
    border: 2px
      ${theme.mode === 'dark' ? theme.text.default : theme.paper.default} solid;

    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 4px;

    grid-area: 1 /2 /4 / 5;
  `
);

export function Grid() {
  const { xAxisQuestions, yAxisQuestions } = useGame();
  const { mode } = useThemeMode();

  const assets: { [key: string]: string } = {
    '00': 'John',
    '01': 'Paul',
    '02': 'Ringo',
    '10': 'Ringo',
    '11': 'George',
    '12': 'John',
    '20': 'Paul',
    '21': 'Ringo',
    '22': 'George',
  };

  const getAsset = (column: number, row: number) =>
    `assets/${assets[`${column}${row}`]}-${mode}.svg`;

  return (
    <Container>
      <YAxisQuestionsList>
        {yAxisQuestions.map((question) => (
          <Question key={question}>{question}</Question>
        ))}
      </YAxisQuestionsList>
      <MainGrid>
        {yAxisQuestions.map((yQuestion, i) =>
          xAxisQuestions.map((xQuestion, j) => (
            <AnswerCell
              img={getAsset(i, j)}
              key={xQuestion + yQuestion}
              xAxisQuestion={xQuestion}
              yAxisQuestion={yQuestion}
            />
          ))
        )}
      </MainGrid>

      <XAxisQuestionsList>
        {xAxisQuestions.map((question) => (
          <Question key={question}>{question}</Question>
        ))}
      </XAxisQuestionsList>
    </Container>
  );
}
